import Adaptive from 'ember-simple-auth/session-stores/adaptive';

export default Adaptive.extend();
